const STORAGE_KEY = 'cc-impersonation'

export type ImpersonationState = {
  orgId: string
  orgName: string
  expiresAt: string
}

export function readImpersonation(): ImpersonationState | null {
  if (typeof window === 'undefined') return null
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as Partial<ImpersonationState>
    if (!parsed.orgId || !parsed.expiresAt) return null
    const expiresAtMs = new Date(parsed.expiresAt).getTime()
    if (!Number.isFinite(expiresAtMs) || expiresAtMs <= Date.now()) {
      clearImpersonation()
      return null
    }
    return {
      orgId: parsed.orgId,
      orgName: parsed.orgName ?? '',
      expiresAt: parsed.expiresAt,
    }
  } catch {
    return null
  }
}

export function writeImpersonation(state: ImpersonationState): void {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state))
  } catch {
    return
  }
}

export function clearImpersonation(): void {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.removeItem(STORAGE_KEY)
  } catch {
    return
  }
}
